<template>
  <div class="px-2 auth">
    <div class="auth-left">
      <validation-observer ref="loginForm">
        <b-form class="auth-login-form mt-2" @submit.prevent="login">
          <!-- email -->
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Email"
              rules="required"
            >
              <b-form-input
                id="email"
                v-model="userEmail"
                class="round"
                name="login-email"
                :state="errors.length > 0 ? false : null"
                placeholder="Enter a username"
                autofocus
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- password -->
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="Password"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="password"
                  v-model="password"
                  :type="passwordFieldType"
                  class="form-control-merge round"
                  :state="errors.length > 0 ? false : null"
                  name="login-password"
                  placeholder="Enter a password"
                />
                <div class="input-group-append">
                  <span class="input-group-text round"
                    ><feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                  /></span>
                </div>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- checkbox -->
          <b-form-group>
            <span class="text-danger">{{ errMsg }}</span>
          </b-form-group>

          <!-- submit button -->
          <b-form-group class="text-center">
            <a class="font-weight-bolder h3 text-success" @click="login"
              >Sign in</a
            >
          </b-form-group>
        </b-form>
      </validation-observer>

      <b-card-text class="text-center mt-2">
        <span>Need help with your username or password ?</span>
      </b-card-text>
    </div>
    <div class="auth-right">
      <div class="auth-right-title">New to our online services?</div>
      <div class="auth-right-text">
        Sign up to book online, manage and pay for shipments, and access a suite
        of products and services designed to simplify your supply chain.
      </div>
      <router-link
        class="btn btn-outline-success round mt-3"
        :to="{ name: 'cont-register' }"
        >Register</router-link
      >
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";

import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import useJwt from "@/auth/jwt/useJwt";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "tanhq",
      password: "123456",
      status: "",
      // validation rules

      errMsg: "",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    login() {
      this.$refs.loginForm
        .validate()
        .then((success) => {
          if (success) {
            useJwt
              .login({
                username: this.userEmail,
                password: this.password,
              })
              .then((response) => {
                const userData = response.data.result;
                useJwt.setToken(response.data.result.apiKey);
                localStorage.setItem("userData", JSON.stringify(userData));
                this.$ability.update(userData.ability);
                if (userData.requestedPasswordReset == 1) {
                  this.$store.commit("appConfig/CHANGE_PASS", true);
                }

                // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
                this.$router
                  .replace(getHomeRouteForLoggedInUser(userData.role))
                  .then(() => {
                    this.$toast({
                      component: ToastificationContent,
                      position: "top-right",
                      props: {
                        title: `Welcome ${
                          userData.fullName || userData.username
                        }`,
                        icon: "CheckIcon",
                        variant: "success",
                        text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                      },
                    });
                  });
              })
              .catch((error) => {
                if (!error.response) {
                  // network error
                  this.errMsg = "Error: Network Error";
                } else {
                  this.errMsg =
                    "Sign in failed. Please check your username or password.";
                }
              });
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.auth {
  @media (min-width: 601px) {
    display: flex;
    margin-bottom: 200px;
  }
}
.auth-left {
  flex: 50%;
  @media (max-width: 600px) {
    width: 100%;
    padding: 10px;
  }
  @media (min-width: 601px) {
    padding-left: 100px;
  }
  @media (min-width: 1024px) {
    padding: 0 3% 0 18%;
    margin: 30px 0;
  }
}
.auth-right {
  flex: 50%;
  @media (max-width: 600px) {
    width: 100%;
    padding: 10px;
  }
  @media (min-width: 601px) {
    padding-right: 100px;
  }
  @media (min-width: 1024px) {
    padding: 13px 18% 0 3%;
    margin: 30px 0;
  }
  border-left: 1px solid #2b938c;
  &-title {
    font-weight: bold;
    font-size: 18px;
    line-height: 2.3;
    display: flex;
    align-items: flex-end;
    letter-spacing: -0.02em;

    color: #2b938c;
  }
  &-text {
    line-height: 1.8;
    display: flex;
    align-items: flex-end;
    letter-spacing: -0.02em;
  }
}
</style>
